module.exports = __webpack_public_path__ + "img/episode7.c9a7f118.png";